import Accordion from "../../../components/accordion";
import ProfTestChat from "./prof-test-chat";

export default class PageModule {
    constructor() {
        this.initAccordion();
        this.initChat();
        this.observeWidget()
    }

    initAccordion() {
        const accordion = new Accordion('accordion-faq');
    }

    initChat() {
        const chat = new ProfTestChat('prof-test-chat');
    }

    observeWidget() {
        const observer = new IntersectionObserver((entries) => {
            const  isIntersecting = entries[0].isIntersecting;

            if (isIntersecting) {
              const $widget = document.querySelector(".prof-constructor_test-widget");

              if ($widget) {
                  $widget.classList.remove('-pup-up')
              }
            } else {
                const $widget = document.querySelector(".prof-constructor_test-widget");

                if ($widget) {
                    $widget.classList.add('-pup-up')
                }
            }
        });

        observer.observe(document.querySelector(".prof-constructor_chat-holder"), {
            threshold: 1.0,
        });
    }
}